import React from 'react';
import { useTranslation } from 'react-i18next';
import './footer.less';
import './footer-mobile.less';

function Footer() {
    const { t } = useTranslation();
    
    return (
        <footer className='footer'>
            <div className='footer-anchor-group'>
                <nav className='navigation'>
                    <ul>
                        <li>
                            <a className='policy-ethics' href={process.env.REACT_APP_POLICY_AND_ETHICS} target="_blank" rel='noreferrer'>
                                 {t('FOOTER_POLICIES_AND_ETHICS')}
                            </a>
                        </li>
                        <li className='contact'>
                            <a  href={process.env.REACT_APP_CONTACT_URL} target="_blank" rel='noreferrer'>
                                {t('FOOTER_CONTACT')}
                             </a>
                        </li>
                    </ul>
                </nav>      
            </div>
            <div className='copyright'>
                <span>&copy; {new Date().getFullYear()}, Prometric</span>
            </div>
        </footer>
    );
}

export default Footer;
